import 'vue2-toast/lib/toast.css';
import Vue from 'vue'
import Toast from 'vue2-toast';
Vue.use(Toast, {
  type: 'center',
  duration: 2500,
  wordWrap: true,
  width: '80%'
});